import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

export type PageContainerWidth = "default" | "full"

const widthClasses: Record<PageContainerWidth, string> = {
  default: "max-w-none",
  full: "max-w-none",
}

// Every page in this package stretches to the full available width — no
// page here caps at 1920px. `PageContainerWidth` stays a two-value type so
// a page can still opt back into app-shell.md's capped `default` canvas
// later without touching every call site.
export function PageContainer({
  children,
  className,
  width = "default",
}: {
  children: ReactNode
  className?: string
  width?: PageContainerWidth
}) {
  return (
    <div
      className={cn(
        "mr-auto flex w-full min-w-0 flex-1 flex-col gap-4",
        widthClasses[width],
        className
      )}
    >
      {children}
    </div>
  )
}
